import { render, staticRenderFns } from "./FormAddons.vue?vue&type=template&id=0f3bdafe&scoped=true"
import script from "./FormAddons.vue?vue&type=script&lang=js"
export * from "./FormAddons.vue?vue&type=script&lang=js"
import style0 from "./FormAddons.vue?vue&type=style&index=0&id=0f3bdafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3bdafe",
  null
  
)

export default component.exports